import { ExpandModes, ExpansionContextProvider } from 'utils/contexts/expansion';
import { PushPreviewContextProvider } from './PushPreviewContextProvider';

export const PushContext = ({ children }: { children: React.ReactNode }) => {
  return (
    <PushPreviewContextProvider>
      <ExpansionContextProvider initialMode={ExpandModes.collapse}>
        {children}
      </ExpansionContextProvider>
    </PushPreviewContextProvider>
  );
};
